module.exports = __webpack_public_path__ + "a00f4003b62a1ccb8d4adc652d70a8e4.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/10_column_small_x1/public/modules/image/sample.png
// module id = 245
// module chunks = 0